import React, { useState } from "react";
import { Button, CircularProgress } from '@mui/material';
import { WidgetProps } from "@rjsf/utils";
import axios from "@/_utils/axios";
import { useToast } from '@/components/_common/Toast';

const AutoActionLinkWidget = (props: WidgetProps) => {
  const { success, error } = useToast();
  const [loading, setLoading] = useState(false);
  let buttonProps: Partial<typeof Button> = {
    variant: "contained",
    color: "success",
  };

  if (props.name?.toLowerCase()?.includes('reject') || props.label?.toLowerCase()?.includes('reject')) {
    buttonProps = {
      variant: "outlined",
      color: "secondary",
    };
  }

  const onClick = async () => {
    if (loading) {
      return;
    }

    setLoading(true);
    props?.formContext?.setWidgetLoadingData(true);
    try {
      await axios.post(props.value, null, { baseURL: '' });
      success('Action executed successfully');
    } catch (err) {
      error('Error executing action');
      console.error(err);
    } finally {
      setLoading(false);
      props?.formContext?.setWidgetLoadingData(false);
    }
  }

  if (!props.value) {
    return null;
  }

  return (
    <Button
      fullWidth
      disabled={!loading && props?.formContext?.widgetLoadingData}
      onClick={onClick}
      { ...buttonProps }
      startIcon={loading ? <CircularProgress size={20} /> : null}
    >
      {props.label}
    </Button>
  );
};

export default AutoActionLinkWidget;